import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';
import { smoothScrollToElement } from '../../../scroll';
import { toggleSection, onClickAccHandler, sectionIsOpen, accScroll } from '../../../page-accordion';
import PromoMessage from '../../promo-message';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.shown = props.route && props.route.match(/your-report/);
        this.chapter = 0;
        this.open_section = this.getOpenSection(props);

        let open_chapters = [];

        if (props.route.match(/your-report/)) {
            open_chapters.push(props.route);
        }

        this.state = { open_chapters: open_chapters };
    }

    componentDidMount() {
        if (this.props.route.match(/your-report/)) {
            const scrollTo = this.props.route == 'your-report' ? 'essential-birth-report' : `#${this.props.route}`;
            smoothScrollToElement(document.querySelector(scrollTo));
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.shown = nextProps.route.match(/your-report/);

        this.open_section = this.getOpenSection(nextProps);
        // start new
        if (nextProps.route != this.props.route) {
            if (this.shown) {
                let opened = toggleSection(this.state.open_chapters, nextProps.route);
                const state = this.state;
                state.open_chapters = opened;
                this.setState(state);
            }
            return true;
        }
        if (nextState != this.state) {
            return true;
        }

        return false;
    }

    componentDidUpdate() {
        if (this.props.route === 'your-report') {
            accScroll('essential-birth-report', 300);
        }
    }

    render() {
        return (
            <ebr-report id='your-report' className={this.shown ? 'is-shown' : null}>
                {this.renderSampleHeader()}
                {this.renderSections()}
            </ebr-report>
        );
    }

    renderSampleHeader = () => {
        if (this.props.is_sample) {
            return (
                <section id='your-report-about-sample' className='is-shown'>
                    <h1>{this.props.report.product.display.sections[0].block[1].content[0].title}</h1>
                    {this.props.report.product.display.sections[0].block[1].content[0].body.map(p => <p>{p}</p>)}
                </section>
            );
        }

        return null;
    }

    /* eslint-disable max-len */
    renderSections = () => {
        const sections = this.props.report.product.display.sections;

        return sections.map((section, index) => {
            if (index > 1 && index < sections.length - 1) { //don't use sections; 1, 2, last
                const id = section.section_code.replace(/_/g, '-');

                return (
                    <section
                        id={`your-report-${id}`}
                        className={this.open_section == `your-report-${id}` ? 'is-shown' : ''}
                    >
                        <h1>{!this.props.is_sample ? `${section.super_title}. ` : ''}{section.title}</h1>
                        <h3 className='has-margin-20-bottom has-text-boulder'>{section.sub_title}</h3>
                        {this.renderSectionBlocks(section.block, id)}
                        {this.renderPromoMessage(section.promo_tags)}
                    </section>
                );
            }

            return null;
        });
    }

    renderSectionBlocks = (blocks, id) => {
        this.chapter = 0;
        return blocks.map((block, index) => {
            if (block.type == 'Interpretation') {
                return this.renderInterp(block.content, id);
            } else if (block.type == 'Content') {
                return this.renderContent(block.content, index);
            }

            return null;
        });
    }

    renderContent = (content, index) => {
        if (content && _.isArray(content)) {
            return content.map(c => {
                if (c.body) {
                    if (c.title && index > 0) {
                        return [
                            <h1>{c.title}</h1>,
                            c.body.map(p => <p>{p}</p>),
                        ];
                    }

                    return c.body.map(p => <p>{p}</p>);
                } else if (c.html) {
                    return (<div dangerouslySetInnerHTML={{__html: c.html}} />);
                }

                return null;
            });
        }

        return null;
    }

    renderInterp = (interp, id) => {
        return interp.map(i => {
            this.chapter++;
            const chapter = `your-report-${id}-chapter-${this.chapter}`;
            return (
                <div
                    className={`report-item ${sectionIsOpen(this.state.open_chapters, chapter) ? 'is-open' : 'is-closed'}`}
                    id={chapter}
                >
                    <a
                        onClick={(e) => this.goTo(e, chapter)}
                        className='report-item-tab'
                    >
                        <h2>{i.title}</h2>
                    </a>
                    <div className='report-item-content'>
                        {this.renderInterpSymbols(i)}
                        {i.body.map(p => <p>{p}</p>)}
                    </div>
                </div>
            );
        });
    }

    renderInterpSymbols = (interp) => {
        if (interp.symbol_header) {
            return (
                <h1 className='has-text-boulder symbol has-margin-5-top has-margin-5-bottom'>
                    {interp.symbol_header}
                </h1>
            );
        }

        return null;
    }

    renderPromoMessage = (tags) => {
        if (tags) {
            tags.push(this.props.is_sample ? 'ebrsample' : 'ebr');

            if (_.contains(tags, 'beyond')) {
                tags.push(this.props.has_birth_time ? 'bt' : 'wobt');

                return (
                    <div className='has-padding-17-left has-padding-17-right has-margin-21-bottom'>
                        <PromoMessage placement='in-product' tags={tags.toString()} />
                    </div>
                );
            }

            return (
                <p className='has-text-center has-margin-21-top has-padding-17-left has-padding-17-right'>
                    <PromoMessage placement='in-product' tags={tags.toString()} />
                </p>
            );
        }

        return null;
    }

    goTo = (e, chapter) => {
        e.preventDefault();
        let clickResult = onClickAccHandler(this.state.open_chapters, chapter, this.props.route);
        const state = this.state;
        state.open_chapters = clickResult[0];
        this.setState(state);
        if (clickResult[1] == true) {
            this.props.routeTo(chapter);
        }
        if (clickResult[2] == true) {
            accScroll(chapter, 400);
        }
    }

    getOpenSection = (props) => {
        return props.route && props.route == 'your-report'
            ? `your-report-${props.report.product.display.sections[2].section_code.replace(/_/g, '-')}`
            : props.route.replace(/-chapter-.*/, '');
    }
    /* eslint-enable max-len */
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    is_sample: state.report && state.report.product_code && state.report.product_code == 'essential-birth-sample',
    has_birth_time: state.report && state.report.product && state.report.product.restrictions
        && state.report.product.restrictions[0] && state.report.product.restrictions[0] == 'has_birth_time',
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);